import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { System } from 'projects/sigv-library/src/model/src/lib/system.model';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DisplayType } from '../../../../enum/src/lib/display-type.enum';
import { TodoResponsibility } from '../../../../enum/src/lib/todo-responsibility.enum';
import { Todo } from '../../../../model/src/lib/todo.model';
import { isNullOrEmpty } from '../../../../util/src/lib/is-null-or-empty';
import { MenuService } from '../../../core/services/menu.service';
import { StorageService } from '../../../core/services/storage.service';

@Component({
  selector: 'sigv-todo',
  templateUrl: './todo.component.html',
  styleUrls: ['./todo.component.scss']
})
export class TodoComponent implements OnInit, OnDestroy {
  @Input() ownTodos$: BehaviorSubject<Todo[]> = new BehaviorSubject<Todo[]>([]);
  @Input() subTodos$: BehaviorSubject<Todo[]> = new BehaviorSubject<Todo[]>([]);
  @Input() routeMap!: Map<string, string>;
  displayTypes = DisplayType;
  currentDisplayType: DisplayType = DisplayType.GRID;
  private envSystem$: BehaviorSubject<System[]> = new BehaviorSubject<System[]>([]);
  /**
   * enum
   */
  DisplayType = DisplayType;
  /**
   * flag of redirection
   */
  redirectMode = false;

  /** enum */
  TodoResponsibility = TodoResponsibility;
  private readonly destroy$ = new Subject();
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private menuService: MenuService,
    private storageService: StorageService,
  ) {}

  ngOnInit(): void {
    this.menuService
      .getRbacSystemList()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (system) => {
          this.envSystem$.next(system);
        }
      );
    this.ownTodos$.pipe(takeUntil(this.destroy$)).subscribe(
      (ownTodos) => {
        if (ownTodos.length > 0){
          this.redirectIfNeed();
        }
      }
    );
    this.subTodos$.pipe(takeUntil(this.destroy$)).subscribe(
      (subTodos) => {
        if (subTodos.length > 0){
          this.redirectIfNeed();
        }
      }
    );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeDisplayType(displayType: DisplayType): void {
    this.currentDisplayType = displayType;
  }

  getBadgeStatusClassName(counter: number): string {
    if (counter < 10) {
      return 'low';
    } else if (counter >= 10 && counter < 20) {
      return 'medium';
    } else if (counter >= 20) {
      return 'high';
    }
    return '';
  }

  getAllProcessesCount(type: TodoResponsibility): string {
    const todos = type === TodoResponsibility.OWN ? this.ownTodos$.value : this.subTodos$.value;
    return todos
      .reduce((acc, todo) => {
        acc = acc + todo.totalCount;
        return acc;
      }, 0)
      .toString();
  }

  redirectToPage(
    event: any,
    companyId: number,
    systemCode: string,
    processDefKey: string,
    taskDefKey: string,
    isSubstitute?: boolean,
  ): void {
    if (event){
      event?.preventDefault();
    }
    const responsibility = isSubstitute ? 'Sub' : 'Own';
    const availableRoute = this.routeMap.get(`${processDefKey}_${taskDefKey}_${responsibility}_Com`) ?? this.routeMap.get(`${processDefKey}_${taskDefKey}_${responsibility}`) ?? this.routeMap.get(`${processDefKey}_${taskDefKey}`);
    const needCompanyId = this.routeMap.get(`${processDefKey}_${taskDefKey}_${responsibility}_Com`);
    // const availableRoute = null;
    console.log('availableRoute', availableRoute);

    if (availableRoute){
      if (needCompanyId) {
        this.router.navigateByUrl(`${companyId}/${availableRoute};companyId=${companyId}`);
      } else {
        this.router.navigateByUrl(`${companyId}/${availableRoute}`);
      }
      return;
    } else {
      const targetSystem = this.envSystem$.value.find(x => x.systemCode === systemCode);
      const redirectUrl = `${targetSystem?.systemHostUrl}/todo-item/company/${companyId}/process/${processDefKey}/task/${taskDefKey}?companyId=${companyId}&isSubstitute=${isSubstitute}`;
      if (this.storageService.session.getItem('previousTodoUrl') !== redirectUrl){
        this.storageService.session.setItem('previousTodoUrl', redirectUrl);
        console.log('redirect to', redirectUrl);
        window.location.href = redirectUrl;
      } else {
        this.router.navigateByUrl('/');
        console.error('route of todo item was not found!');
      }
    }
  }

  redirectIfNeed(): void{
    const params = this.route.snapshot.params;
    const isSubstitute = this.route.snapshot.queryParamMap.get('isSubstitute') === 'true';
    const { companyId, processDefKey, taskDefKey } = params;
    if (isNullOrEmpty(companyId) === false
    && isNullOrEmpty(processDefKey) === false
    && isNullOrEmpty(taskDefKey) === false){
      const allTodos = this.ownTodos$.value.concat(this.subTodos$.value);
      let targetSystemCode = '';
      allTodos.every(
        (todo) => {
          const targetProcess = todo.processes.find(
            (process) => process.processDefKey === processDefKey
          );
          if (targetProcess){
            targetSystemCode = targetProcess?.systemCode;
            return false;
          }
          return true;
        }
      );
      this.redirectToPage(
        null, companyId, targetSystemCode, processDefKey, taskDefKey, isSubstitute
      );
    }
  }
}
